export enum ELocalization {
    Ru = 'ru',
    En = 'en',
    Cn = 'cn',
}

export namespace NLocalization {
    export const shortname = (lang: string) => {
        switch (lang as ELocalization) {
            case ELocalization.Ru:
                return 'РУ';
            case ELocalization.En:
                return 'EN';
            case ELocalization.Cn:
                return '中国';
        }
    };
    export const fullname = (lang: string, locale: string) => {
        if (locale) {
            const languages: any = {
                ru: {
                    ru: 'Русский',
                    en: 'Английский',
                    cn: 'Китайский',
                },
                en: {
                    ru: 'Russian',
                    en: 'English',
                    cn: 'Chinese',
                },
                cn: {
                    ru: '俄罗斯',
                    en: '英语',
                    cn: '中文',
                },
            };
            return languages[locale][lang];
        } else {
            switch (lang as ELocalization) {
                case ELocalization.Ru:
                    return 'Русский';
                case ELocalization.En:
                    return 'English';
                case ELocalization.Cn:
                    return '中文';
            }
        }
    };
}

export enum EStatusValidateProductsType {
    Save = 'SAVE',
    Publish = 'PUBLISH',
    Rejected = 'REJECTED',
    Archive = 'ARCHIVE',
    Hidden = 'HIDDEN',
    Delete = 'DELETE',
    Suspended = 'SUSPENDED',
    VALIDATE = 'VALIDATE'
}

export namespace NStatusValidateProductsType {
    export const text = (value: string) => {
        switch (value as EStatusValidateProductsType) {
            case EStatusValidateProductsType.Save:
                return 'Сохранен';
            case EStatusValidateProductsType.Publish:
                return 'Опубликован';
            case EStatusValidateProductsType.Rejected:
                return 'Отклонен';
            case EStatusValidateProductsType.Archive:
                return 'Архивный';
            case EStatusValidateProductsType.Hidden:
                return 'Скрытый';
            case EStatusValidateProductsType.Delete:
                return 'Удален';
            case EStatusValidateProductsType.Suspended:
                return 'Приостановлен';
            case EStatusValidateProductsType.VALIDATE:
                return 'На валидации'
            default:
                return value;
        }
    }
    export const color = (value: string) => {
        switch (value as EStatusValidateProductsType) {
            case EStatusValidateProductsType.Save:
                return 'geekblue';
            case EStatusValidateProductsType.Publish:
                return 'green';
            case EStatusValidateProductsType.Rejected:
                return 'volcano';
            case EStatusValidateProductsType.Archive:
                return '';
            case EStatusValidateProductsType.Hidden:
                return 'gold';
            case EStatusValidateProductsType.Delete:
                return 'red';
            case EStatusValidateProductsType.Suspended:
                return 'magenta';
            case EStatusValidateProductsType.VALIDATE:
                return 'cyan';
            default:
                return value;
        }
    }
}

export enum EProfileOrderStatus {
    New = 'NEW',
    InProgress = 'IN_PROGRESS',
    Formed = 'FORMED',
    Done = 'DONE',
    Canceled = 'CANCELED',
    Updated = 'UPDATED'
}

export namespace NProfileOrderStatus {
    export const color = (status: EProfileOrderStatus) => {
        switch (status) {
            case EProfileOrderStatus.New:
                return '';
            case EProfileOrderStatus.InProgress:
                return 'warning';
            case EProfileOrderStatus.Formed:
                return 'cyan';
            case EProfileOrderStatus.Canceled:
                return 'red';
            case EProfileOrderStatus.Done:
                return 'success';
            case EProfileOrderStatus.Updated:
                return 'blue'
            default:
                return '';
        }
    };
    export const text = (status: EProfileOrderStatus) => {
        switch (status) {
            case EProfileOrderStatus.New:
                return 'Новый';
                // было 'Оформлен'
            case EProfileOrderStatus.InProgress:
                return 'Получен счет/предложение';
            case EProfileOrderStatus.Formed:
                return 'Сформирован';
            case EProfileOrderStatus.Done:
                return 'Завершен';
            case EProfileOrderStatus.Updated:
                return 'Изменен';
            case EProfileOrderStatus.Canceled:
                return 'Отменен';
            default:
                return '';
        }
    };
}

export enum ECatalogCategoryViewType {
    Card = 'card',
    Row = 'row',
}

export enum EOneTimeStatus {
    Pending = 'pending',
    Success = 'success',
    Failed = 'failed',
    Unknown = 'unknown',
}

export enum EHeaderSearchItemType {
    Category = 'category',
    Brand = 'brand',
    Product = 'product',
}

export enum EResponseType {
    Json = 'json',
    Text = 'text',
    Blob = 'blob',
}

export enum EPopupMessageType {
    Success = 'success',
    Error = 'error',
    Info = 'info',
    Warning = 'warning',
}

export enum EPopupNotificationType {
    Success = 'success',
    Info = 'info',
    Warning = 'warning',
    Error = 'error',
}

export enum EPopupModalType {
    Confirm = 'confirm',
    Warning = 'warning',
    Info = 'info',
    Error = 'error',
}

export enum EPageCategory {
    Catalog = 'catalog',
    Profile = 'profile',
    Help = 'help',
    Manufacturer = 'manufacturer',
    Manufacturers = 'manufacturers',
    Product = 'product',
    Requests = 'requests',
}

export enum ECatalogOrderType {
    Desc = 'desc',
    Asc = 'asc',
}

export enum ECatalogSortType {
    Popular = 'popular',
    Price = 'price',
    Rate = 'rate',
    Name = 'name',
}

export enum ECatalogQueryFilterType {
    Add = 'add', // добавить новый целый фильтр
    Remove = 'remove', // удалить целый фильтр
    Replace = 'replace', // заменить в целом фильтре
    Clear = 'clear', // очистить весь фильтр
    Include = 'include', // добавить в целый фильтр
    Exclude = 'exclude', // убрать из целого фильтра
}
export enum ETdmQueriesType{
    Buy = 'BUY',
    Repair = 'REPAIR',
    Manufacture = 'MANUFACTURE'
}
export namespace NTdmQueriesType {
    export const text = (status: ETdmQueriesType) => {
        switch (status) {
            case ETdmQueriesType.Buy:
                return 'Закупка';
            case ETdmQueriesType.Repair:
                return 'Ремонт';
            case ETdmQueriesType.Manufacture:
                return 'Производство';
            default:
                return '';
        }
    };
}

export enum ECatalogDisplayItemType {
    Catalog = 'catalog',
    Custom = 'custom',
}

export enum ECatalogDisplayViewType {
    List = 'list',
    Grid = 'grid',
}

export enum ERegisterType {
    Buyer = 'buyer',
    Manufacturer = 'manufacturer',
    Distributer = 'Distributer',
}

export enum EInnStatus {
    Success = 'success',
    Validating = 'validating',
    Error = 'error',
    Warning = 'warning',
    Unknown = '',
}

export enum EHelpCategories {
    Customers = 'customers',
    Suppliers = 'suppliers',
    AboutProject = 'about',
    TDM = 'tdm',
    LegalInformation = 'legal',
}

export enum EHelpSuppliersPages {
    InstructionsForManufacturers = 'manufacturers',
    InstructionsForTradingCompany = 'trading',
}

export enum EHelpLegalInformationPages {
    GeneralProvisions = 'general',
    UserAgreement = 'agreement',
    PersonalDataProcessingPolicy = 'policy',
}

export enum EProfileType {
    Buyer = 'buyer',
    Admin = 'admin',
    Manufacturer = 'manufacture',
    Distributer = 'distributer',
    Unknown = 'unknown',
}

export enum EProfileTab {
    Account = 'account',
    Company = 'company',
    Products = 'products',
    Sell = 'sell',
    Staff = 'staff',
    Support = 'support',
    Notifications = 'notifications',
    Trading = 'trading',
    Basket = 'basket',
    Orders = 'orders',
    Favourites = 'favourites',
    Compare = 'compare',
    Mail = 'mail',
    TDMQueries = 'tdm',
    Api = 'api'
}

export enum EProfileAccountTab {
    User = 'user',
    Company = 'company',
}

export enum EProfileProductsTab {
    Add = 'add',
    List = 'list',
    Drafts = 'drafts',
    Setup = 'setup',
}

export enum EProfileOrdersTab {
    Transactions = 'transactions',
    Requests = 'requests',
    Feedback = 'feedback',
    Lists = 'lists',
    Analytics = 'analytics',
}

export enum EProfileSellViewType {
    Kanban = 'kanban',
    List = 'list',
    Archive = 'archive',
}

export enum EProfileAddProductType {
    Manually = 'manually',
    Api = 'api',
    Template = 'template',
    Ai = 'ai',
}

export enum EProfileCompareViewType {
    All = 'all',
    Mismatched = 'mismatched',
}

export enum ERegisterStatus {
    Success = 'success',
    Failed = 'failed',
    Bad = 'bad',
}

export namespace NProfileType {
    export const text = (status: EProfileType) => {
        switch (status) {
            case EProfileType.Buyer:
                return 'Покупатель';
            case EProfileType.Admin:
                return 'Администратор';
            case EProfileType.Manufacturer:
                return 'Производитель';
            case EProfileType.Distributer:
                return 'Дистрибьютор';
            case EProfileType.Unknown:
                return 'Неизвестно';
            default:
                return '';
        }
    };
    export const color = (status: EProfileType) => {
        switch (status) {
            case EProfileType.Buyer:
                return 'green';
            case EProfileType.Admin:
                return 'red';
            case EProfileType.Manufacturer:
                return 'yellow';
            case EProfileType.Distributer:
                return 'orange';
            case EProfileType.Unknown:
                return 'gray';
            default:
                return '';
        }
    };
}

export enum ERequestType {
    Approve = 'approve',
    Created = 'created',
}
export namespace NRequestType {
    export const color = (status: ERequestType) => {
        switch (status) {
            case ERequestType.Approve:
                return 'green';
            case ERequestType.Created:
                return 'yellow';
            default:
                return status;
        }
    };
    export const text = (status: ERequestType) => {
        switch (status) {
            case ERequestType.Approve:
                return 'Подтвержден';
            case ERequestType.Created:
                return 'Создан';
            default:
                return status;
        }
    };
}
